import {
    FETCH_ADVERTISEMENT_LIST,
    RESET_ADVERTISEMENT_LIST,
  } from "../../constants/action.constants";
  
  const initialState = {
    list: [],
    others: {
      total: 0,
      offset: 0,
      limit: 20,
    },
  };
  
  const advertisementListReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_ADVERTISEMENT_LIST:
        return { list: action.payload, others: action.others };
      case RESET_ADVERTISEMENT_LIST:
        return initialState;
      default:
        return state;
    }
  };
  
  export default advertisementListReducer;
  